import {config, request} from '../utils'
import {stringify} from 'qs'

export default {
  sendVerifyCode(phoneNo) {
    return request(`/public/sms/verifyCode/group-apply?phoneNo=${phoneNo}`)
  },
  getGroupProperties() {
    return request(`/public/group-property`, {
      method: 'GET',
    })
  },
  submit({verifyCode, ...params}) {
    return request(`${config.apiPrefix}/group-apply?verifyCode=${verifyCode}`, {
      method: 'POST',
      body: params,
    })
  },
  cancel(objectId) {
    return request(`${config.apiPrefix}/group-apply/${objectId}/cancel`, {
      method: 'POST',
    })
  },
  query(params) {
    return request(`${config.apiPrefix}/group-apply?${stringify(params)}`)
  },
}
